export default (() => ({
  heading: {
    marginBottom: '16px',
  },
}));
